import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Components from "./index";
import { patientActions } from "../../core/actions";
import MessageStrip from "../../shared/messagestrip/MessageStrips";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { doctorActions } from "../../core/actions";
import { helperServices } from "../../shared/helper";
import debounce from "lodash.debounce";
import Papa from "papaparse";
import { Add, GetApp } from "@material-ui/icons";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useOrganization } from "../../configurations/OrganizationContext";
import PatientSections from "./PatientSections";
import personDetailsService from "../../core/services/personDetailsService";
import { isValid, format } from "date-fns";
import Calendar from "react-calendar";
import MenuItem from "@mui/material/MenuItem";
import { Collapse, Menu } from "@material-ui/core";
import { ListItemIcon, ListItemText } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { fi } from "date-fns/locale";
import { FILTER_TYPES } from "../../shared/constants";
import {
ORG_CODES
} from "../../shared/constants";
import "./AdminHomeView.css";

function AdminHomeView(props) {
  const org = useOrganization();
  const history = useHistory();
  const DEFAULT_PAGE_SIZE = 16;
  const [showMsgStrip, setShowMsgStrip] = useState(false);
  const [messageDetails, setMessageDetails] = useState({});
  const [showPatientDetail, setshowPatientDetail] = useState(false);
  const [addNew, setAddNew] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchError, setSearchError] = useState("");
  const [showList, setShowList] = useState(false);
  const [patient, setPatient] = useState({ page: 1, pageSize: 50 });
  const [patientSearchList, setPatientSearchList] = useState([]);
  const [searchResultList, setSearchResultList] = useState([]);
  const [showClose, setShowClose] = useState(false);
  const [openAddPatientModal, setOpenAddPatientModal] = useState(false);
  const [reportDownload, setReportDownload] = useState(false);
  const [patientType, setPatientType] = useState("InPatient");

  const today = new Date().toISOString().split("T")[0];
  const sevenDaysAgo = new Date();
  sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
  const maxDate = sevenDaysAgo.toISOString().split("T")[0];
  const [anchorEl, setAnchorEl] = useState(null);
  const [showFilterOption, setShowFilterOption] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("Discharged");
  const formatDate = (date) => {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      "0",
    )}-${String(date.getDate()).padStart(2, "0")}`;
  };

  const [isInitialSearchDone, setIsInitialSearchDone] = useState(false);
  const [dateFrom, setDateFrom] = useState(formatDate(sevenDaysAgo));
  const [dateTo, setDateTo] = useState(formatDate(new Date()));
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [totalCount, setTotalCount] = useState(0);
  const [showCalendar, setShowCalendar] = useState(false);
  const [calendarMode, setCalendarMode] = useState("single");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [dateRange, setDateRange] = useState({ start: null, end: null });
  const [showDate, setShowDate] = useState("");
  const [tags, setTags] = useState([]); // will store objects {type:"text", value} / {type:"date", from,to,display}
  const [reload, setReload] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!openAddPatientModal) return undefined;

    const sidebar = document.getElementById("sidebar");
    const mainPage = document.getElementById("mainpage");
    const sidebarWasCollapsed = sidebar?.classList.contains("sidebar-hidden");
    const mainPageWasCollapsed = mainPage?.classList.contains("sidebar-hidden");

    document.body.classList.add("patient-form-dialog-open");
    sidebar?.classList.add("sidebar-hidden");
    mainPage?.classList.add("sidebar-hidden");

    return () => {
      document.body.classList.remove("patient-form-dialog-open");
      if (!sidebarWasCollapsed) sidebar?.classList.remove("sidebar-hidden");
      if (!mainPageWasCollapsed) mainPage?.classList.remove("sidebar-hidden");
    };
  }, [openAddPatientModal]);

  // Cleanup on unload
  useEffect(() => {
    const handleUnload = () => {
      sessionStorage.removeItem("searchvalue");
    };
    window.addEventListener("beforeunload", handleUnload);
    return () => {
      window.removeEventListener("beforeunload", handleUnload);
    };
  }, []);

  useEffect(() => {
    let searchvalue = JSON.parse(sessionStorage.getItem("searchvalue"));
    console.log("SearchInput", searchvalue);
    if (searchvalue) {
      setShowClose(true);
      setSearchText(searchvalue);
      // build payload with just searchString
      const payload = {
        bodyParams: { searchString: searchvalue, flag: "" },
        dateFrom: "",
        dateTo: "",
        page: 0,
        pageSize: DEFAULT_PAGE_SIZE,
      };
      setPageSize(DEFAULT_PAGE_SIZE);
      setPage(0);
      searchPatientResult(payload);
    }

    getDoctorsList();
  }, []);

  const toggleFilterOptions = (event) => {
    setAnchorEl(event.currentTarget);
    setShowFilterOption(!showFilterOption);
  };

  const handleCloseFilter = () => {
    setShowFilterOption(false);
    setAnchorEl(null);
  };

  const handleFilterChange = (filterType) => {
    setSelectedFilter(filterType);
    setShowFilterOption(false);
    setAnchorEl(null);

    const today = new Date();
    const lastMonth = new Date();
    lastMonth.setMonth(today.getMonth() - 1);

    // 1️⃣ Ensure date tag exists
    const existingDateTag = tags.find((t) => t.type === "date");

    const dateTag = existingDateTag || {
      type: "date",
      from: format(lastMonth, "yyyy-MM-dd"),
      to: format(today, "yyyy-MM-dd"),
      display: `${format(lastMonth, "dd/MM/yyyy")} - ${format(today, "dd/MM/yyyy")}`,
    };

    // 2️⃣ Build filter tag
    const filterTag = {
      type:
        filterType === "Discharged"
          ? FILTER_TYPES.DISCHARGED
          : FILTER_TYPES.FORCE_CLOSE,
      value: filterType,
    };

    // 3️⃣ Build final tag list (remove old filters, keep text/date)
    const updatedTags = [
      ...tags.filter(
        (t) =>
          t.type !== FILTER_TYPES.DISCHARGED &&
          t.type !== FILTER_TYPES.FORCE_CLOSE &&
          t.type !== "date",
      ),
      dateTag,
      filterTag,
    ];

    setTags(updatedTags);

    // 4️⃣ Extract filters ONLY from updatedTags
    const { searchString, dateFrom, dateTo, discharged, forceclose } =
      extractFilters(updatedTags);

    // 5️⃣ Build payload using normalized flags
    const payload = {
      bodyParams: {
        searchString: searchString || "",
        flag: discharged ? "Discharged" : forceclose ? "ForceClose" : "",
      },
      dateFrom,
      dateTo,
      page: 0,
      pageSize: DEFAULT_PAGE_SIZE,
    };

    searchPatientResult(payload);
  };

  const getDoctorsList = (data) => {
    dispatch(
      doctorActions.getDoctorList(data, (resCb) => {
        if (resCb) {
          console.log("called person api");
        }
      }),
    );
  };

  const handleClick = (pDetail, isAddNew) => {
    console.log("selected patient:", pDetail);
    console.log("isAddNew:", isAddNew);
    console.log("org?.id:", org?.id);

    if (isAddNew === true && (org?.orgCode === ORG_CODES.MANASWINI || org?.orgCode === ORG_CODES.VEDAMAAYU)) {
      console.log("→ Opening modal for org 1");
      setAddNew(true);
      setOpenAddPatientModal(true);
      setshowPatientDetail(true);
      dispatch(patientActions.setPatientDetails(pDetail));
    } else if (isAddNew === true && (org?.orgCode === ORG_CODES.MNH)) {
      console.log("→ Navigating to PatientOneStepOnboard for org:", org?.id);
      history.push({
        pathname: "/PatientOneStepOnboard",
      });
      return;
    } else {
      console.log("→ Existing patient click, pDetail:", pDetail);
      console.log("→ pDetail.visit:", pDetail?.visit);
      setAddNew(false);
      dispatch(patientActions.setPatientDetails(pDetail));
      setshowPatientDetail(true);
      setTimeout(() => {
        let patientId = pDetail?.visit?.patientId;
        let visitId = pDetail?.visit?.id;
        console.log("→ patientId:", patientId, "visitId:", visitId);
        props.history.push({
          pathname: `/PatientSections/${patientId}/${visitId}`,
        });
      }, 200);
    }
    console.log("Add new state:", addNew);
    console.log("pDetail:", pDetail);
  };

  const handlenextpageAggrid = (searchVal, currentPage, pSize) => {
    const nextPage = page + 1;
    setPage(nextPage);

    const {
      searchString,
      dateFrom: df,
      dateTo: dt,
      discharged,
      forceclose,
    } = extractFilters(tags);

    const payload = {
      bodyParams: {
        searchString: searchString || "",
        flag: discharged ? "Discharged" : forceclose ? "ForceClose" : "", // ✅ Pass discharged flag for pagination
      },
      dateFrom: df || "",
      dateTo: dt || "",
      page: nextPage,
      pageSize: pSize || pageSize,
    };

    searchPatientResult(payload);
    setReload(true);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  const handleInputChange = (event) => {
    console.log("event is ", event);
    if (
      event &&
      event.target &&
      event.target.value &&
      event.target.value.length &&
      event.target.value.length >= 3
    ) {
      setLoading(true);
      setShowClose(true);
    } else {
      setLoading(false);
    }
    console.log("spinloading", loading);
    let value = event.target.value;
    validateAndChange(value);
    sessionStorage.setItem("searchvalue", JSON.stringify(value));
  };

  const validateAndChange = (value) => {
    if (showDate) setShowDate("");
    if (dateRange?.start || dateRange?.end) {
      setDateRange({ start: null, end: null });
      setSelectedDate(null);
    }

    setSearchText(value);

    if (value.length < 3) {
      setPageSize(0);
      setShowMsgStrip(false);
      setIsInitialSearchDone(false);
    }

    if (!value) {
      console.log(
        "patientsearchlist null array !value : ",
        value,
        patientSearchList,
      );
      setShowMsgStrip(false);
    }

    if (value.length >= 3) {
      setSearchError("");
      setPage(0);
      setPageSize(DEFAULT_PAGE_SIZE);

      // Use unified payload
      const payload = {
        bodyParams: { searchString: value, flag: "" },
        dateFrom: "", // date filters come from tags, not typed input
        dateTo: "",
        page: 0,
        pageSize: DEFAULT_PAGE_SIZE,
      };
      setPageSize(DEFAULT_PAGE_SIZE);
      debounceSearchPatientResult(payload);
      setIsInitialSearchDone(true);
    }

    sessionStorage.setItem("searchvalue", JSON.stringify(value));
  };

  const getFullName = (fname, mname, lname) => {
    var fullName = "";

    console.log("fname : ", fname);
    console.log("mname : ", mname);
    console.log("lname : ", lname);

    if (!fname || fname == null) fname = "";
    if (!mname || mname == null) mname = "";
    if (!lname || lname == null) lname = "";

    let pfname = fname;
    let pmname = mname;
    let plname = lname;

    console.log("pfname : ", pfname);
    console.log("pmname : ", pmname);
    console.log("plname : ", plname);

    if (pfname == null) pfname = "";
    if (pmname == null) pmname = "";
    if (plname == null) plname = "";

    pfname = pfname.charAt(0).toUpperCase() + pfname.slice(1);
    pmname = pmname.charAt(0).toUpperCase() + pmname.slice(1);
    plname = plname.charAt(0).toUpperCase() + plname.slice(1);

    if (fname && lname) {
      fullName = pfname + " " + plname;
    } else if (fname && mname) {
      fullName = pfname + " " + pmname;
    } else if (fname && mname && lname) {
      fullName = pfname + " " + pmname + " " + plname;
    } else {
      fullName = pfname + "      ";
    }

    console.log("fullName : ", fullName);
    return fullName;
  };

  const searchPatientResult = (payload) => {
    if (!payload) return;

    setReload(true);

    // PatientListing uses AG Grid's client-side pagination. Fetch the complete
    // filtered result set so the grid can calculate its footer and navigation
    // from all matching rows. The search API treats size=0 as "no LIMIT".
    const sanitized = {
      bodyParams: payload.bodyParams || { searchString: "", flag: "" },
      dateFrom: payload.dateFrom || "",
      dateTo: payload.dateTo || "",
      page: 0,
      pageSize: 0,
    };

    console.log("patient search payload:", sanitized);

    setLoading(true);

    // 🚨 IMPORTANT: clear old results immediately
    setPatientSearchList([]);
    setSearchResultList([]);

    dispatch(
      patientActions.patientSearch(sanitized, (resCb) => {
        setLoading(false);
        if (!resCb) return;

        console.log("patient search resCb:", resCb);

        if (resCb.state === "success") {
          let docInfo = null;

          // Save doctor info if returned
          if (resCb.personmap) {
            Object.keys(resCb.personmap).forEach((key) => {
              const person = resCb.personmap[key];
              docInfo = {
                first_name: person.first_name,
                id: person.personId,
                email: person.email,
              };
            });
            dispatch(doctorActions.setDoctorInfo(docInfo));
          }

          // Build patient list
          let searchList = [];

          if (
            resCb.patientListCollection &&
            resCb.patientListCollection.length > 0
          ) {
            searchList = resCb.patientListCollection.map((pat) => ({
              ...pat,
              fullName: getFullName(pat.fname, pat.mname, pat.lname),
            }));
          }

          // ALWAYS replace lists with fresh data
          setPatientSearchList(searchList);
          setSearchResultList(searchList);
        } else {
          // API returned error
          console.log("Patientlist error:", resCb?.messageStrip);

          // Reset lists on error
          setPatientSearchList([]);
          setSearchResultList([]);
        }

        console.log("Final API response:", resCb);
      }),
    );
  };

  // Debounced wrapper for unified search
  const debounceSearchPatientResult = useCallback(
    debounce((payload) => searchPatientResult(payload), 500),
    [],
  );

  console.log("loading true", loading);

  const closeMessageStrip = () => {
    console.log("closing msg strip fn in patientlist");
    setShowMsgStrip(!showMsgStrip);
  };

  const clearSearch = () => {
    setSearchText("");
    setTags([]);
    setLoading(false);
    setShowClose(false);
    // run empty search (clear)
    const payload = {
      bodyParams: { searchString: "", flag: "" },
      dateFrom: "",
      dateTo: "",
      page: 0,
      pageSize: DEFAULT_PAGE_SIZE,
    };
    setPageSize(DEFAULT_PAGE_SIZE);
    setPage(0);
    debounceSearchPatientResult(payload);
  };

  const closePatientFormModal = () => {
    setOpenAddPatientModal(false);
    setAddNew(false);
  };

  const updatePatientDetails = (event, payment) => {
    console.log("patient added successfully:", event);

    if (event && event.successMessages) {
      setMessageDetails({
        message: event.successMessages[0],
        success: "success",
      });

      setTimeout(() => {
        let patientId, visitId, erpCustId, name;

        if (event.patientresp.visit) {
          patientId = event.patientresp.visit.patientId;
          visitId = event.patientresp.visit.id;
          erpCustId = event.patientresp.erpCustId;
          name = event.patientresp.fname;
        }

        if (org?.orgCode === "manaswini") {
          if (payment === "payment") {
            props.history.push({
              pathname: `/Payment/${name}/${patientId}/${visitId}/${erpCustId}`,
            });
          } else {
            props.history.push({
              pathname: `/PatientSections/${patientId}/${visitId}`,
            });
          }
        } else{
          dispatch(
            patientActions.registrationFees(
              erpCustId,
              0,
              visitId,
              patientId,
              org?.orgCode,
              [],
              (resCb) => {
                if (resCb && resCb.successMessages) {
                  console.log(
                    "resCb in registration fees in case of mnh or vedamaayu: ",
                    resCb,
                  );
                  props.history.push({
                    pathname: `/PatientSections/${patientId}/${visitId}`,
                  });
                }
              },
            ),
          );
        }
      }, 3000);
      setReload(true);
    } else {
      setMessageDetails({
        message: event?.errorMessages?.[0] || "Unknown error",
        error: "error",
      });
    }
  };

  const handleReportDownload = () => {
    setReportDownload(!reportDownload);
  };

  const handlePatientTypeChange = (value) => {
    setPatientType(value);
  };

  const handleDateFromChange = (e) => {
    setDateFrom(e.target.value);
  };

  const handleDateToChange = (e) => {
    setDateTo(e.target.value);
  };

  // extractFilters reads from tags object state
  const extractFilters = (tagList = tags) => {
    const textTag = tagList.find((t) => t.type === "text");
    const dateTag = tagList.find((t) => t.type === "date");

    const discharged = tagList.find((t) => t.type === FILTER_TYPES.DISCHARGED);

    const forceclose = tagList.find((t) => t.type === FILTER_TYPES.FORCE_CLOSE);

    return {
      searchString: textTag ? textTag.value : "",
      dateFrom: dateTag ? dateTag.from : "",
      dateTo: dateTag ? dateTag.to : "",
      discharged,
      forceclose,
    };
  };

  // handlesearchOnDateRange now uses unified searchPatientResult - kept for compatibility
  const handlesearchOnDateRange = (inDateFrom, inDateTo, tagList) => {
    const formattedDateFrom = inDateFrom
      ? format(new Date(inDateFrom), "yyyy-MM-dd")
      : "";
    const formattedDateTo = inDateTo
      ? format(new Date(inDateTo), "yyyy-MM-dd")
      : "";

    // If tagList is provided and contains a text object, prefer that; otherwise use extractFilters
    let searchString = "";
    if (Array.isArray(tagList) && tagList.length > 0) {
      // convert tagList (legacy strings) -> combined string
      searchString = tagList.join(",");
    } else {
      searchString = extractFilters().searchString;
    }

    const searchPayload = {
      bodyParams: { searchString: searchString || "", flag: "" },
      dateFrom: formattedDateFrom,
      dateTo: formattedDateTo,
      page,
      pageSize,
    };

    setLoading(true);
    setMessageDetails({});
    setShowMsgStrip(false);

    // Use unified search
    debounceSearchPatientResult(searchPayload);
  };

  const handleDownload = (dateFrom, dateTo, singleDate) => {
    let data = {
      dateFrom,
      dateTo,
      text: singleDate,
      bodyParams: {
        searchString: "",
        flag: "",
      },
      page,
      pageSize,
    };

    dispatch(
      patientActions.patientSearch(data, (resCb) => {
        if (!resCb.patientListCollection) return;

        console.log(
          "patient search in report download : ",
          resCb.patientListCollection,
        );

        const typePatient = patientType;
        const fromDate = dateFrom;
        const toDate = dateTo;

        console.log("typePatienttypePatient", typePatient, fromDate, toDate);

        const filtered = resCb.patientListCollection.filter((patient) => {
          console.log("patient.visitList", patient.visitList.length);
          console.log("patient.visitList", patient.visitList);
          console.log("Patientid :", patient.id);

          return patient.visitList.some((visit) => {
            const visitDate = new Date(visit.visitDate).getTime();
            console.log("visit.visitDate", visit.visitDate, fromDate, toDate);
            console.log("visitDate", visitDate);
            console.log(
              "new Date(fromDate).getTime()",
              new Date(fromDate).getTime(),
            );
            console.log(
              "new Date(toDate).getTime()",
              new Date(toDate).getTime(),
            );
            console.log("visit.type:", visit.type);
            console.log("typepatient:", typePatient);

            const matchesType =
              typePatient === "Walkin"
                ? (visit.visitflag || "").toLowerCase() === "walkin"
                : visit.type === typePatient &&
                  (typePatient !== "InPatient" ||
                    (visit.visitflag || "").toLowerCase() !== "walkin");

            return (
              visitDate >= new Date(fromDate).setHours(0, 0, 0, 0) &&
              visitDate <= new Date(toDate).setHours(23, 59, 59, 999) &&
              matchesType
            );
          });
        });

        console.log("patientListCollect after processing", filtered);

        let newpatientReport = [];

        filtered.forEach((item) => {
          const uniqueIds = {};
          const filteredData = item.visitList.filter((vi) => {
            const matchesType =
              typePatient === "Walkin"
                ? (vi.visitflag || "").toLowerCase() === "walkin"
                : vi.type === typePatient &&
                  (typePatient !== "InPatient" ||
                    (vi.visitflag || "").toLowerCase() !== "walkin");
            if (!uniqueIds[vi.Id] && matchesType) {
              uniqueIds[vi.Id] = true;
              return true;
            }
            return false;
          });

          filteredData.forEach((vi) => {
            const date = new Date(vi.visitDate);
            const options = { year: "numeric", month: "long", day: "2-digit" };
            const formattedVisitDate = date.toLocaleDateString(
              "en-US",
              options,
            );

            const doctorName = item.person
              ? `${item.person.first_name} ${item.person.last_name}`
              : "";

            newpatientReport.push({
              MAIN: item.id,
              Name: `${item.fname} ${item.mname} ${item.lname}`,
              "Phone No": item.phno,
              "Doctor Name": doctorName,
              "Visit Id": vi.id,
              "Visit Type": vi.visitflag || vi.type,
              "Visit Date": formattedVisitDate,
            });
          });
        });

        console.log("newpatientReport", newpatientReport);

        const sortePateintdData = newpatientReport.sort(
          (a, b) => a.MAIN - b.MAIN,
        );
        const csvData = Papa.unparse(sortePateintdData);
        const blob = new Blob([csvData], { type: "text/csv" });
        const link = document.createElement("a");

        link.href = window.URL.createObjectURL(blob);
        link.download = `${typePatient}_report.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setReportDownload(!reportDownload);
      }),
    );
  };

  const toggleCalendar = () => {
    setShowCalendar(!showCalendar);
  };

  // Updated Calendar handler to create date tag objects and call unified search
  const handleCalendarChange = (value) => {
    if (Array.isArray(value)) {
      const [start, end] = value;
      if (!isValid(start) || !isValid(end)) {
        console.warn("Invalid date range:", value);
        return;
      }

      setDateRange({ start, end });
      setSelectedDate(null);
      setShowCalendar(false);

      const startStr = format(start, "yyyy-MM-dd");
      const endStr = format(end, "yyyy-MM-dd");
      const displayRange = `${format(start, "dd/MM/yyyy")} – ${format(
        end,
        "dd/MM/yyyy",
      )}`;

      setShowDate(displayRange);
      setSearchText("");

      // Build date tag object
      const dateTag = {
        type: "date",
        from: startStr,
        to: endStr,
        display: displayRange,
      };

      // Remove old date tag, keep other tags
      const otherTags = tags.filter((t) => t.type !== "date");
      const updated = [...otherTags, dateTag];
      setTags(updated);

      // use unified search
      const payload = {
        bodyParams: {
          searchString: extractFilters(updated).searchString || "",
          flag: extractFilters(updated).discharged
            ? "Discharged"
            : extractFilters(updated).forceclose
              ? "ForceClose"
              : "",
        },
        dateFrom: startStr,
        dateTo: endStr,
        page: 0,
        pageSize: DEFAULT_PAGE_SIZE,
      };
      setPageSize(DEFAULT_PAGE_SIZE);
      setPage(0);
      searchPatientResult(payload);
      return;
    }

    if (!isValid(value)) {
      console.warn("Invalid single date:", value);
      return;
    }

    if (calendarMode === "single") {
      setSelectedDate(value);
      setDateRange({ start: null, end: null });
      setShowCalendar(false);

      const formattedApi = format(value, "yyyy-MM-dd");
      const formattedDisplay = format(value, "dd/MM/yyyy");

      setShowDate(formattedDisplay);
      setSearchText("");

      const dateTag = {
        type: "date",
        from: formattedApi,
        to: formattedApi,
        display: formattedDisplay,
      };

      const otherTags = tags.filter((t) => t.type !== "date");
      const updated = [...otherTags, dateTag];
      setTags(updated);

      // unified search with single date as both from & to
      const payload = {
        bodyParams: {
          searchString: extractFilters(updated).searchString || "",
          flag: extractFilters(updated).discharged
            ? "Discharged"
            : extractFilters(updated).forceclose
              ? "ForceClose"
              : "",
        },
        dateFrom: formattedApi,
        dateTo: formattedApi,
        page: 0,
        pageSize: DEFAULT_PAGE_SIZE,
      };
      setPageSize(DEFAULT_PAGE_SIZE);
      setPage(0);
      searchPatientResult(payload);
    } else {
      setDateRange({ start: value, end: null });
      setSelectedDate(null);
    }
  };

  const clearCalendarSelection = () => {
    setSelectedDate(null);
    setDateRange({ start: null, end: null });
    setShowDate("");
    setTags((prevTags) => prevTags.filter((t) => t.type !== "date"));
    setCalendarMode("single");
    setReload(true);
  };

  // runANDSearch now reads tags state and calls unified search
  const runANDSearch = (tagList = tags) => {
    const {
      searchString,
      dateFrom: df,
      dateTo: dt,
      discharged,
      forceclose,
    } = extractFilters(tagList);

    // Stop API call if nothing to search
    if (!searchString && !df && !dt) {
      console.log("No filters → skipping search");
      return;
    }

    const payload = {
      bodyParams: {
        searchString: searchString || "",
        flag: discharged ? "Discharged" : forceclose ? "ForceClose" : "",
      },
      dateFrom: df || "",
      dateTo: dt || "",
      page: 0,
      pageSize: DEFAULT_PAGE_SIZE,
    };

    setPage(0);
    setPageSize(DEFAULT_PAGE_SIZE);
    setReload(true);
    debounceSearchPatientResult(payload);
  };

  const handleKeyChange = (e) => {
    if (e.key === "Enter" && searchText.trim() !== "") {
      const textTag = {
        type: "text",
        value: searchText.trim(),
      };

      const otherTags = tags.filter((t) => t.type !== "text");
      const updated = [...otherTags, textTag];
      setTags(updated);

      runANDSearch(updated);

      setSearchText("");
    }
  };

  const clearTagsValue = (tag) => {
    const updated = tags.filter((t) => t !== tag);
    setTags(updated);

    if (updated.length > 0) {
      runANDSearch(updated); // <-- PASS UPDATED TAGS
    } else {
      setSearchText("");
      setSearchResultList([]);
      clearCalendarSelection();
      setReload(false);
    }
  };

  return (
    <main className="mainsection list-patient">
      {showMsgStrip && (
        <MessageStrip
          msgStrip={messageDetails}
          closeMessageStrip={closeMessageStrip}
        />
      )}

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          marginBottom: 3,
          marginLeft: 2,
          marginRight: 2,
        }}
      >
        <Grid container justifyContent="space-between" alignItems="baseline">
          <Grid
            item
            xs={12}
            md={10}
            sx={{
              mt: 2,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <form
              className="main-navbar__search w-100 d-md-flex d-lg-flex  "
              onSubmit={(event) => handleSubmit(event)}
            >
              <div className="input-group input-group-seamless ">
                <div className="input-group-prepend mb-2">
                  <span className="input-group-text">
                    <i style={{ color: `#111b21` }} className="material-icons">
                      search
                    </i>
                  </span>
                </div>

                <TextField
                  id="global-search"
                  className="navbar-search mb-2 menu-search bg-white custom-width"
                  placeholder="Search Patients By Name / PhoneNumber / MAIN /Aadhaar Number....."
                  autoFocus
                  value={searchText}
                  type="search"
                  onChange={(e) => {
                    setSearchText(e.target.value);
                    setReload(false);
                  }}
                  onKeyDown={(e) => {
                    handleKeyChange(e);
                  }}
                  InputProps={{
                    style: { paddingLeft: "15px", height: "35px" },
                  }}
                />

                {tags.length > 0 && (
                  <div
                    style={{
                      display: "flex",
                      gap: "8px",
                      flexWrap: "wrap",
                      marginTop: "10px",
                    }}
                  >
                    {tags.map((tag, i) => (
                      <div
                        key={i}
                        style={{
                          padding: "5px 10px",
                          background: "#e0e0e0",
                          borderRadius: "20px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {/* <span style={{ marginRight: "8px", fontSize: "12px" }}>
                          {tag.type === "text" ? tag.value : tag.display}
                        </span> */}

                        <span style={{ marginRight: "8px", fontSize: "12px" }}>
                          {tag.type === "text"
                            ? tag.value
                            : tag.type === FILTER_TYPES.DISCHARGED
                              ? tag.value // show "Discharged"
                              : tag.type === FILTER_TYPES.FORCE_CLOSE
                                ? tag.value // show "Force Close"
                                : tag.display}
                        </span>
                        <span
                          style={{
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: "bold",
                          }}
                          onClick={() => {
                            clearTagsValue(tag);
                          }}
                        >
                          ✕
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </form>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            md={2}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            className="text-center buttonsetconfirm"
          >
            {/* <div className="d-flex align-items-center">

             <div>
              <a title="Patient_Search" style={{ marginLeft: "5px" }}>
                <i className="material-icons" onClick={toggleCalendar}>
                  calendar_month
                </i>
              </a>
            </div>
            <div className="position-relative d-flex justify-content-between filter-container">
              <div className="text-secondary pname">
                <i
                  title="Filter"
                  className="material-icons m-2 filter-icon"
                  onClick={toggleFilterOptions}
                  style={{
                    marginRight: "70px !important",
                    marginTop: "4px !important",
                    cursor: "pointer",
                  // marginLeft: "85px",

                  }}
                >
                  filter_list
                </i>

                <Menu
                  id="filter_options"
                  anchorEl={anchorEl}
                  open={showFilterOption}
                  onClose={handleCloseFilter}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                >

                  <MenuItem onClick={handleFilterChange}>
                    <ListItemText primary="Discharged" className="text-secondary" />
                  </MenuItem>

                </Menu>
              </div>
            </div>
            {(helperServices.CheckAccessLevel("patients") ||
              helperServices.CheckAccessLevel("InsurancePatients")) && (
                <div className="button-container">
                  <Button
                    type="submit"
                    variant="contained"
                    className="newPatient"
                    style={{
                      padding: "5px 10px",
                      fontSize: "12px",
                      marginRight: "20px",
                      marginLeft: "30px",
                    }}
                    onClick={() => handleClick("", true)}
                  >
                    <AddIcon style={{ marginRight: "2px" }} />
                    <span className="button-text">Add New Patient</span>
                  </Button>
                </div>
              )}
</div> */}

            <div
              className="d-flex align-items-center justify-content-evenly gap-4"
              style={{ width: "100%" }}
            >
              {/* Calendar Icon */}
              <div>
                <a title="Patient_Search" style={{ marginLeft: "5px" }}>
                  <i className="material-icons" onClick={toggleCalendar}>
                    calendar_month
                  </i>
                </a>
              </div>

              {/* Filter Icon with Menu */}
              <div className="position-relative filter-container">
                <div className="text-secondary pname">
                  <i
                    title="Filter"
                    className="material-icons m-2 filter-icon"
                    onClick={toggleFilterOptions}
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    filter_list
                  </i>

                  <Menu
                    id="filter_options"
                    anchorEl={anchorEl}
                    open={showFilterOption}
                    onClose={handleCloseFilter}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                  >
                    <MenuItem onClick={() => handleFilterChange("Discharged")}>
                      <ListItemText
                        primary="Discharged"
                        className="text-secondary"
                      />
                    </MenuItem>

                    <MenuItem onClick={() => handleFilterChange("ForceClose")}>
                      <ListItemText
                        primary="Force Close Patient"
                        className="text-secondary"
                      />
                    </MenuItem>
                  </Menu>
                </div>
              </div>

              {/* Add New Patient Button (conditionally rendered) */}
              {(helperServices.CheckAccessLevel("patients") ||
                helperServices.CheckAccessLevel("InsurancePatients")) && (
                  <div className="button-container">
                    <Button
                      type="submit"
                      variant="contained"
                      className="newPatient"
                      style={{
                        padding: "5px 10px",
                        fontSize: "12px",
                        // marginLeft: "0px",
                      }}
                      onClick={() => handleClick("", true)}
                    >
                      <AddIcon style={{ marginRight: "2px" }} />
                      <span className="button-text">Add New Patient</span>
                    </Button>
                  </div>
                )}
            </div>

            {showCalendar && (
              <div
                className="position-absolute"
                style={{
                  zIndex: 1001,
                  backgroundColor: "white",
                  padding: "8px",
                  borderRadius: "4px",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
                  right: "10px",
                  top: "70px",
                }}
              >
                <div className="d-flex justify-content-between mb-2">
                  <button
                    type="button"
                    className={`btn btn-sm ${calendarMode === "single"
                      ? "btn-primary"
                      : "btn-outline-primary"
                      }`}
                    onClick={() => setCalendarMode("single")}
                    style={{ fontSize: "0.75rem" }}
                  >
                    Single Date
                  </button>
                  <button
                    type="button"
                    className={`btn btn-sm ${calendarMode === "range"
                      ? "btn-primary"
                      : "btn-outline-primary"
                      }`}
                    onClick={() => setCalendarMode("range")}
                    style={{ fontSize: "0.75rem" }}
                  >
                    Date Range
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-danger"
                    onClick={clearCalendarSelection}
                    style={{ fontSize: "0.75rem" }}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    onClick={() => setShowCalendar(false)}
                    className="btn btn-sm btn-light border-0"
                    title="Close calendar"
                  >
                    <i
                      className="material-icons"
                      style={{ fontSize: "1.2rem" }}
                    >
                      close
                    </i>
                  </button>
                </div>

                <Calendar
                  onChange={handleCalendarChange}
                  value={
                    calendarMode === "single"
                      ? selectedDate
                      : dateRange.start && dateRange.end
                        ? [dateRange.start, dateRange.end]
                        : dateRange.start
                  }
                  selectRange={calendarMode === "range"}
                  maxDate={new Date()}
                />

                <div className="mt-2 text-center">
                  <small className="text-muted">
                    {calendarMode === "single"
                      ? isValid(selectedDate)
                        ? `Selected: ${format(selectedDate, "PPP")}`
                        : "Select a date"
                      : dateRange.start && dateRange.end
                        ? isValid(dateRange.start) && isValid(dateRange.end)
                          ? `Range: ${format(dateRange.start, "PPP")} – ${format(
                            dateRange.end,
                            "PPP",
                          )}`
                          : "Select a valid date range"
                        : "Select a date or range"}
                  </small>
                </div>
              </div>
            )}
          </Grid>
        </Grid>
      </Box>

      {searchError && (
        <div style={{ color: "#EC4147", fontSize: "12px" }}>
          <p>
            <span>{searchError}</span>
          </p>
        </div>
      )}

      <div className="main-content-container container-fluid cont">
        <div className="row">
          <div className="mb-12 col-sm-12 col-md-12 hpcol bg">
            {showList && (
              <div className="blog-comments card pcard">
                <div className="p-0 card-body">
                  {patientSearchList.length > 0 &&
                    patientSearchList.map((currPatObj, idx) => (
                      <div
                        className="blog-comments__item d-flex p-1 cpointer"
                        key={idx}
                        onClick={() => handleClick(currPatObj, false)}
                      >
                        <div className="blog-comments__content">
                          <div className="blog-comments__meta">
                            <div className="text-dark">
                              {currPatObj.fullName}
                            </div>
                            <p className="m-0 text-muted">
                              Age: {currPatObj.age} Years | Aadhaar:{" "}
                              {currPatObj.adhar} | Phone: {currPatObj.phno}
                            </p>
                            <p className="m-0 text-muted">
                              {currPatObj.area} {currPatObj.city}{" "}
                              {currPatObj.state}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <Components.PatientListing
        key={`${JSON.stringify(tags)}`}
        searchText={searchText}
        patientsearchlist={patientSearchList}
        searchListResult={searchResultList}
        searchPatientResult={handlenextpageAggrid}
        parentCallBack={clearSearch}
        isInitialSearchDone={isInitialSearchDone}
        page={page}
        dateRange={dateRange}
        tags={tags}
        pageReload={reload}
      />
      {addNew && (org?.orgCode === ORG_CODES.MANASWINI || org?.orgCode === ORG_CODES.VEDAMAAYU) && (
        <Components.PatientForm
          patientInfo={[]}
          openPatientForm={openAddPatientModal}
          type="AdminHomeView"
          closePatientForm={closePatientFormModal}
          onSuccess={updatePatientDetails}
        />
      )}

      {reportDownload && (
        <Dialog
          open={reportDownload}
          onClose={handleReportDownload}
          id="Download_report1"
        >
          <DialogTitle>Download Report</DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleReportDownload}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingBottom: "20px",
              }}
            >
              <div style={{ flex: 1 }}>
                <FormControlLabel
                  control={
                    <Radio
                      value="OutPatient"
                      checked={patientType === "OutPatient"}
                      onChange={() => handlePatientTypeChange("OutPatient")}
                    />
                  }
                  label="Outpatient"
                />
              </div>
              <div style={{ flex: 1 }}>
                <FormControlLabel
                  control={
                    <Radio
                      value="InPatient"
                      checked={patientType === "InPatient"}
                      onChange={() => handlePatientTypeChange("InPatient")}
                    />
                  }
                  label="Inpatient"
                />
              </div>
              <div style={{ flex: 1 }}>
                <FormControlLabel
                  control={
                    <Radio
                      value="Walkin"
                      checked={patientType === "Walkin"}
                      onChange={() => handlePatientTypeChange("Walkin")}
                    />
                  }
                  label="Walkin"
                />
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ flex: 1 }}>
                <TextField
                  type="date"
                  value={dateFrom}
                  defaultValue={maxDate}
                  onChange={handleDateFromChange}
                  max={today}
                  label="Date From"
                  fullWidth
                />
              </div>
              <div style={{ flex: 1, marginLeft: "8px" }}>
                <TextField
                  type="date"
                  value={dateTo}
                  defaultValue={today}
                  onChange={handleDateToChange}
                  max={today}
                  label="Date To"
                  fullWidth
                />
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <div style={{ marginTop: "20px", textAlign: "center" }}>
              <Button
                onClick={() => handleDownload(dateFrom, dateTo)}
                variant="contained"
                color="success"
                sx={{ textTransform: "capitalize" }}
              >
                Download
              </Button>
            </div>
          </DialogActions>
        </Dialog>
      )}
    </main>
  );
}

export default AdminHomeView;
